import IconSVG from '../../../../styles/svg-icons';
import { OnHoverTooltip } from '../../../common';
import { IColumnDefinition } from './types/ColumnDefinition';

export const collapseStickRightColumn: IColumnDefinition<any> = {
        columnKey: 'collapse-stick-right-column',
        renderColumnHeaderContent: () =>
            <OnHoverTooltip overlay={'Click to show or hide actions'}>
                <button className="btn-link secondary">
                    <IconSVG name="collapse-right" width={16} height={16} />
                    <span>Actions</span>
                </button>
            </OnHoverTooltip>,
        renderColumnContent: () => '',
        className: 'data-list-cell-icon-collapsed visible-collapse-icon keep-while-collapsed overflow-visible',
        stickRight: true
}